export const getIdenticalPicture = (picture, pictures) =>
  pictures.find((pic) => pic.crc32 === picture.crc32);
